/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../modules/infra/i18n';

const CampaignVerbiage = ({ getDayVerbiage, getEndDate, displayUserType, displayFrequency, displayTime, displayStartDate, timezone }) => (
  <div className="u-width-400 c-campaign-verbiage u-text-center u-margin-auto u-mt+ u-mb+">
    {t('engage:campaign_verbiage.full_description', {
      frequency: displayFrequency,
      dayPart: displayFrequency === 'weekly' ? ` ${t('engage:campaign_verbiage.on')} ${getDayVerbiage()}` : ` ${getDayVerbiage()}`,
      time: displayTime,
      timezone: timezone,
      userType: displayUserType,
      startDate: displayStartDate,
      endDate: getEndDate()
    })}
  </div>
);

CampaignVerbiage.propTypes = {
  getDayVerbiage: PropTypes.func.isRequired,
  getEndDate: PropTypes.func.isRequired,
  displayUserType: PropTypes.string.isRequired,
  displayFrequency: PropTypes.string.isRequired,
  displayTime: PropTypes.string.isRequired,
  displayStartDate: PropTypes.string.isRequired,
  timezone: PropTypes.string.isRequired,
};

export default CampaignVerbiage;
